module.exports = "/images/twitter.svg?a7f7f3db5ff0ae810c38b6936163db50";